import React from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import { RootState } from '@Redux/detail/store';
import { LightBox } from '@lion-design/core';
import styles from './styles.module.scss';
import Title from './subComponents/Title';
import GroupList from './subComponents/GroupList';

interface I_Props {
    open: boolean;
    ToggleLightBox: () => void;
    storyData?: {
        url: string;
    };
}

const GroupTripInfoFlight: React.FC<I_Props> = ({ open, ToggleLightBox }) => {
    const { FlightInfo } = useSelector((state: RootState) => state.groupReducer);

    return (
        <LightBox
            open={open}
            ToggleLightBox={ToggleLightBox}
            className={cN(styles.container, 'group_tripinfo_flight')}
        >
            <Title />
            <GroupList GroupList={FlightInfo!.GroupList} />
        </LightBox>
    );
};

export default GroupTripInfoFlight;
